/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  Form,
  Row,
  Col,
  Spin,
  Card,
  Input,
  DatePicker,
} from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import Table from 'components/Table';
import { getPeriodosFiscales } from 'api/configuraciones/periodosFiscales';
import FormSubmitControls from 'components/FormSubmitControls';
import currencyFormatter from 'utils/currencyFormatter';
import Select from 'components/Select';
import ModalDelete from 'components/ModalDelete';
import { checkToken } from 'api/utils';
import { onError, onSuccess } from 'utils/handlers';
import moment from 'moment';
import {
  SLUG_PATTERN,
} from 'utils/patterns';
import { getEstadosGlobales } from 'api/catalogos';
import {
  getRetirosDeAhorros,
  getRetiroDeAhorro,
  postRetiroDeAhorro,
  patchRetiroDeAhorro,
  deleteRetiroDeAhorro,
} from 'api/nominas/retiroDeAhorros/retiroDeAhorros';
import { getConfiguracionDescuentos } from 'api/nominas/descuentos/configuracionDescuentos';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import CurrencyInput from 'components/CurrencyInput';
import { getPeriodosDeNominasDetalles } from 'api/nominas/periodos/periodosDeNominasDetalle';
import { formatReceivedValues } from 'utils/formatValues';
import { getRetirosDeAhorrosDetalle } from 'api/nominas/retiroDeAhorros/retiroDeAhorrosDetalles';
import { getPeriodosDeNominas } from 'api/nominas/periodos/periodosDeNominas';
import filterPeriodos from 'components/filtradorPeriodos';

import ModalConfirmation from 'components/ModalConfirmation';
import {
  ESTATUS_ACTIVO,
  ESTATUS_CANCELADO,
  ESTATUS_AUTORIZADO,
  ESTATUS_INACTIVO,
} from '../../../utils/constants';

// Componentes
import RetiroDeAhorrosDetalles from './RetiroDeAhorrosDetalles';

export const retiroDeAhorrosPermission = {
  permissionModel: 'descuentodevolucionahorro',
  catalogsModels: [],
  tabsModels: [],
};

const RetiroDeAhorros = ({ permission }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [form] = Form.useForm();
  const [open, setVisible] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [estados, setEstados] = useState();
  const [visibleAlert, setVisibleAlert] = useState();
  const [descuentos, setDescuentos] = useState([]);
  const [tiposDeNominaEmpleado, setTiposDeNominaEmpleado] = useState([]);
  const [selectedTipoNominaEmpleado, setSelectedTipoNominaEmpleado] = useState();
  const [periodosDeNominas, setPeriodosDeNominas] = useState([]);
  const [periodosDeNominaDetalles, setPeriodosDeNominasDetalles] = useState([]);
  const [periodosDeNominaDetallesFiltered, setPeriodosDeNominaDetallesFiltered] = useState([]);
  const [periodosFiscales, setPeriodosFiscales] = useState([]);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [confirmationVisibleEstatus, setConfirmationVisibleEstatus] = useState(false);
  const [estatusInactivo, setEstatusInactivo] = useState(false);
  const [estatusAutorizado, setEstatusAutorizado] = useState(false);
  const [estadosFiltered, setEstadosFiltered] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [tipoDeNominaEmpleadosId, setTipoDeNominaEmpleadoId] = useState();

  const fetchData = async () => {
    setLoading(true);
    const _data = await getRetirosDeAhorros();
    setData(_data);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _descuentos,
        _periodosDeNominas,
        _periodosDeNominasDetalle,
        _periodosFiscales,
        _tiposNominaEmpleado,
        _data,
      ] = await Promise.all([
        getEstadosGlobales(),
        getConfiguracionDescuentos({ aplica_acumulado: true }),
        getPeriodosDeNominas({ estados_globales: ESTATUS_AUTORIZADO }),
        getPeriodosDeNominasDetalles(),
        getPeriodosFiscales({ estados_globales: ESTATUS_AUTORIZADO }),
        getTiposDeNominasEmpleados({ estados_globales: ESTATUS_AUTORIZADO }),
        getRetirosDeAhorros(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setDescuentos(_descuentos);
        setPeriodosDeNominas(_periodosDeNominas);
        setPeriodosDeNominasDetalles(_periodosDeNominasDetalle);
        setPeriodosFiscales(_periodosFiscales);
        setTiposDeNominaEmpleado(_tiposNominaEmpleado);
        setData(_data);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setEstatusInactivo(false);
    setEstatusAutorizado(false);
    setSelectedRowKeys([]);
    setVisible(false);
    setIsEditing(false);
    form.resetFields();
  };

  const onClickAdd = () => {
    setEstadosFiltered(estados);
    form.setFieldsValue({
      fecha_de_devolucion: moment(new Date()).format('DD/MM/YYYY'),
    });
    onCancel();
    setVisible(true);
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteRetiroDeAhorro(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    setIsEditing(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _retiroDeAhorro = await getRetiroDeAhorro(match.id);

    // Mostrar bien el periodo al editar
    const periodoFiscal = periodosDeNominas.find((periodo) => periodo.tipo_de_nomina_empleado === _retiroDeAhorro?.tipo_de_nomina_empleado)?.periodo_fiscal;
    const descripcionPeriodo = periodosFiscales.find((e) => e.id === periodoFiscal)?.periodo;
    const periodosFiltered = filterPeriodos(_retiroDeAhorro?.tipo_de_nomina_empleado, periodoFiscal, periodosDeNominas, periodosDeNominaDetalles);
    setPeriodosDeNominaDetallesFiltered(periodosFiltered);

    if (_retiroDeAhorro?.estados_globales === ESTATUS_ACTIVO
      || _retiroDeAhorro?.estados_globales === ESTATUS_INACTIVO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_INACTIVO
      || estado?.id === ESTATUS_ACTIVO));
    }
    if (_retiroDeAhorro?.estados_globales === ESTATUS_AUTORIZADO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_AUTORIZADO));
      setEstatusAutorizado(true);
    }
    if (_retiroDeAhorro?.estados_globales === ESTATUS_INACTIVO) {
      setEstatusInactivo(true);
    }
    setSelectedTipoNominaEmpleado(_retiroDeAhorro?.tipo_de_nomina_empleado);
    // eslint-disable-next-line max-len
    const retiroAhorroDetalleData = await getRetirosDeAhorrosDetalle({ descuento_devolucion_ahorro: _retiroDeAhorro?.id });
    setTimeout(() => {
      if (_retiroDeAhorro) {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceivedValues(_retiroDeAhorro));
          form.setFieldValue('no_empleados', retiroAhorroDetalleData.length);
          form.setFieldValue('periodo_fiscal', descripcionPeriodo);
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await form.validateFields();
      const fechaActual = moment().format('DD-MM-YYYY');
      const values = {
        ...form.getFieldsValue(),
        fecha_de_devolucion: fechaActual,
      };
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchRetiroDeAhorro(key, values) : postRetiroDeAhorro(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
      );
    }
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
    clave: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
    ],
  };

  const handleOnFinishConfirmation = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una nómina ya autorizada');
        return;
      }
      const vals = {
        ...form.getFieldValue(),
        estados_globales: ESTATUS_AUTORIZADO,
      };
      const res = await patchRetiroDeAhorro(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setConfirmationVisible(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishConfirmationEstatus = async () => {
    setConfirmationVisibleEstatus(false);
  };

  const columns = [
    {
      titleText: 'No. de Documento',
      dataIndex: 'no_documento',
      key: 'no_documento',
      width: 300,
    },
    {
      titleText: 'Folio Agrupador',
      dataIndex: 'folio_agrupador',
      key: 'folio_agrupador',
      width: 300,
    },
    {
      titleText: 'Fecha de Retiro',
      dataIndex: 'fecha_de_devolucion',
      key: 'fecha_de_devolucion',
      width: 300,
    },
    {
      titleText: 'Concepto a Retirar',
      dataIndex: 'descuento',
      key: 'descuento',
      width: 300,
      render: (val) => descuentos.find((desc) => desc?.id === val)?.concepto,
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_de_nomina_empleado',
      key: 'tipo_de_nomina_empleado',
      width: 300,
      render: (val) => tiposDeNominaEmpleado.find((tne) => tne?.id === val)?.descripcion,
    },
    {
      titleText: 'Importe Acumulado',
      dataIndex: 'importe_devolucion_total',
      key: 'importe_devolucion_total',
      width: 300,
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Periodo de Nómina',
      dataIndex: 'periodo_de_nomina_detalle',
      key: 'periodo_de_nomina_detalle',
      width: 300,
      render: (val) => {
        const periodoRes = periodosDeNominaDetalles.find((periodo) => periodo?.id === val);
        return `${periodoRes?.numero_de_nomina} (${periodoRes?.fecha_inicial} al ${periodoRes?.fecha_final})`;
      },
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 300,
      render: (val) => estados?.find((estado) => estado?.id === val)?.descripcion,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <Table
            data={data}
            cols={columns}
            allowExport
            rowSelection={rowSelection}
            handleOnRowClick={handleOnRowClick}
            controls={{
              onClickAdd,
              onClickEdit: () => onClickEdit(),
              onClickDelete,
            }}
            disableDelete={
              data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
            }
            customActions={[
              {
                onClick: () => setConfirmationVisible(true),
                permission: { model: 'descuentodevolucionahorro', action: 'autorizar' },
                text: 'Autorizar',
                icon: <CheckCircleOutlined />,
                disabledBySelection: false,
                className: 'success',
                disabled: !selectedRowKeys?.length
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_CANCELADO
                  || data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_INACTIVO,
              },
            ]}
            permission={permission}
          />
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Retiro de Ahorro`}
            extra={(
              <FormSubmitControls
                onFinish={() => form.submit()}
                onCancel={onCancel}
                loading={loading}
                onFinishText="Guardar y Continuar"
              />
            )}
            bordered={false}
          >
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              scrollToFirstError
              name="general"
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="no_documento"
                    label="No. de Documento"
                    hasFeedback
                  >
                    <Input
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="folio_agrupador"
                    label="Folio Agrupador"
                    hasFeedback
                  >
                    <Input
                      disabled
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="fecha_de_devolucion"
                    rules={rules.required}
                    label="Fecha de Retiro"
                    initialValue={moment()}
                    hasFeedback
                  >
                    <DatePicker
                      allowClear
                      format="DD/MM/YYYY"
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="tipo_de_nomina_empleado"
                    rules={rules.required}
                    label="Tipo de Nómina Empleado"
                    hasFeedback
                  >
                    <Select
                      allowClear
                      onChange={(value) => {
                        setTipoDeNominaEmpleadoId(value);
                        setPeriodosDeNominaDetallesFiltered([]);
                        form.resetFields(['periodo_de_nomina_detalle', 'periodo_fiscal']);
                      }}
                      dataSource={tiposDeNominaEmpleado}
                      disabled={estatusAutorizado || estatusInactivo || isEditing}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="descuento"
                    rules={rules.required}
                    label="Concepto a Retirar"
                    hasFeedback
                  >
                    <Select
                      allowClear
                      dataSource={descuentos}
                      render={(val) => `${val?.clave} - ${val?.concepto}`}
                      disabled={estatusAutorizado || estatusInactivo}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="no_empleados"
                    label="No. de Empleados"
                    hasFeedback
                  >
                    <Input
                      allowClear
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <CurrencyInput
                    name="importe_acumulado_total"
                    label="Importe Acumulado"
                    allowClear
                    hasFeedback
                    disabled
                  />
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="periodo_fiscal"
                    rules={rules.required}
                    label="Periodo Fiscal"
                    hasFeedback
                  >
                    <Select
                      dataSource={periodosFiscales}
                      onChange={(value) => {
                        const periodosFiltered = filterPeriodos(tipoDeNominaEmpleadosId, value, periodosDeNominas, periodosDeNominaDetalles);
                        setPeriodosDeNominaDetallesFiltered(periodosFiltered);
                        form.resetFields(['periodo_de_nomina_detalle']);
                      }}
                      disabled={estatusAutorizado || estatusInactivo}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="periodo_de_nomina_detalle"
                    rules={rules.required}
                    label="Periodo de Nómina"
                    hasFeedback
                  >
                    <Select
                      dataSource={periodosDeNominaDetallesFiltered}
                      keyProp="id"
                      render={(periodoDeNominaDetalle) => `${periodoDeNominaDetalle.numero_de_nomina} (${periodoDeNominaDetalle.fecha_inicial} al ${periodoDeNominaDetalle.fecha_final})`}
                      disabled={estatusAutorizado || estatusInactivo}
                      allowClear
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="estados_globales"
                    rules={rules.required}
                    label="Estatus"
                    hasFeedback
                    initialValue={1}
                  >
                    <Select
                      allowClear
                      dataSource={estadosFiltered}
                      disabled={!selectedRowKeys.length || estatusAutorizado || estatusInactivo}
                      onChange={(val) => {
                        if (val === ESTATUS_INACTIVO) {
                          setConfirmationVisibleEstatus(true);
                        }
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              {selectedRowKeys?.length ? (
                <RetiroDeAhorrosDetalles
                  permission={permission}
                  selectedTipoNominaEmpleado={selectedTipoNominaEmpleado}
                  selectedRetiroAhorro={selectedRowKeys[0]}
                  formEncabezado={form}
                  estatusAutorizadoInactivo={estatusAutorizado || estatusInactivo}
                />
              ) : null}
            </Form>
          </Card>
        )}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Retiro De Ahorro ${form.getFieldValue('no_documento')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmation}
          onFinishText="Continuar"
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          title="Confirmación"
          contentTitle={`Autorizar el Retiro De Ahorro ${form.getFieldValue('no_documento')}?`}
          subContent="Esta acción no podra revertirse"
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmationEstatus}
          onFinishText="Continuar"
          onCancel={() => {
            setConfirmationVisibleEstatus(false);
            form.setFieldValue('estados_globales', 1);
          }}
          open={confirmationVisibleEstatus}
          title="Confirmación"
          contentTitle={`Inactivar el Retiro De Ahorro ${form.getFieldValue('no_documento')}?`}
          subContent="Esta acción no podra revertirse"
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default RetiroDeAhorros;
